<template>
    <v-row v-if="!$store.getters.progress && load" class="ma-0 pb-offset">
        <show
            :id="id"
            :models="models"
            :infos="infos"
            topClass=""
        ></show>

        <crud
            class="mt-4"
            title='Record Telefonici'
            action-icon='phone'
            model-def='telephonerecords'
            :default-input='{cli_id: id}'
            :sub-filters='subFilters'
            action-position='absolute'
            :position-left="true"
            :position-right="false"
            direction="right"
        ></crud>

        <activities
            class="pt-4"
            model-class="cli"
            :model-id="id"
        ></activities>

        <dms-uploader
            class="mt-4"
            :id="id"
            attachable-type="cli"
        ></dms-uploader>

        <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
                <v-fab-transition>
                    <v-btn
                        v-on="{ ...tooltip }"
                        @click.native="$eventBusUtility.goTo($router, 'clis-edit', id)"
                        color="primary"
                        dark
                        fixed
                        bottom
                        right
                        fab>
                        <v-icon>edit</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <span>Modifica</span>
        </v-tooltip>

    </v-row>
</template>

<script>

    import Activities from '@/components/common/Activities'

    export default {
        name: 'cli',
        components: {
            Activities,
        },

        props: {
            id: Number,
        },

        data() {
            return {
                infos: {},
                models: {},
                subFilters: {clis: this.id},
                load: false,
            }
        },

        created() {
            this.initialize()
        },

        methods: {

            initialize() {
                this.axios.get('clis/' + this.id).then(response => {
                    this.models = response.data.models
                    this.infos = response.data.infos
                    this.$store.commit('endProgress')
                    this.load = true

                }, response => {
                    // error callback
                })
            },
        }        
    }
</script>

<style>

</style>